import { Section } from '../models/productFormData';
import {ProductForm} from "../apiCalls/auth";

type PermBlock = { read: boolean; edit: boolean };

const isPerm = (p: unknown): p is PermBlock =>
    typeof p === 'object' && p !== null && 'read' in p && 'edit' in p;

export const applyPermissions = (
    sections: Section[],
    perms?: Record<string, unknown> | ProductForm,
): Section[] => {
  const map = perms as Record<string, unknown> | undefined;

  return sections.reduce<Section[]>((out, s) => {
    const raw = map?.[s.permission];          // ya no da TS7053

    const p: PermBlock = isPerm(raw) ? raw : { read: false, edit: false };

    if (!p.read) return out;

    out.push({
      ...s,
      canAddRows: p.edit ? s.canAddRows : false,
      fields: s.fields.map(f => ({ ...f, disabled: !p.edit || f.disabled })),
    });
    return out;
  }, []);
};
